/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SystemModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import { SystemConfig } from 'ajs/modules/system/factories/system-config.item.factory';
import './system-settings-controller-config-container.component.less';

/**
 * @description Component for Controller Config of System Settings Modal.
 * @author Suraj Kumar
 */
@Component({
    selector: 'system-settings-controller-config-container',
    templateUrl: './system-settings-controller-config-container.component.html',
})
export class SystemSettingsControllerConfigContainerComponent {
    @Input()
    public editable: SystemConfig;
}
